export enum EntityType
{
    PRODUCT = 1,
    VENDOR = 2
}